import { render, staticRenderFns } from "./Chart_Topic.vue?vue&type=template&id=066a31e4&scoped=true"
import script from "./Chart_Topic.vue?vue&type=script&lang=js"
export * from "./Chart_Topic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066a31e4",
  null
  
)

export default component.exports